
/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
 obj.on(ev, fn);
 return {
 destroy: function () {
 obj.removeListener(ev, fn);
 }
 };
}



//////////////////
// WEBPACK FOOTER
// ./lib/on.js
// module id = 41
// module chunks = 0